export const DEFAULT_CLASSNAMES =
	'wp-block wp-block-post-title block-editor-block-list__block editor-post-title editor-post-title__input rich-text';

export const REGEXP_NEWLINES = /[\r\n]+/g;
